import React from "react";
import aboutus from '../assets/aboutus.jpg';
import aboutus2 from '../assets/aboutus2.jpg';
import aboutus3 from '../assets/aboutus3.jpg';
import amir from '../assets/amir.jpg';
import allinone from '../assets/allinone.jpg';
// import aboutus4 from '../assets/aboutus4.jpg';
// import aboutus5 from '../assets/aboutus5.jpg';
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <>
    <div className="responsive-container-block bigContainer">
      <div className="responsive-container-block Container">
       
        <div className="responsive-container-block textSide">
          <p className="text-blk heading">About Us</p>
          <h2>My Journey and the Vision Behind Future MedsAcademy</h2>
          <p className="text-blk subHeading">
          I am Amir Akhtar, the founder of Future MedsAcademy and a medical student at the University of Messina, Italy. Having traveled to over thirteen countries, I have had the privilege of connecting with an international community from more than forty-five different nations. Through these experiences, I have gained a deep understanding of various education systems, visa processes, and the struggles students face when applying to universities abroad.
          </p>
          {/* {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12"
            >
              <div className="cardImgContainer">
                <img
                  className="cardImg"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/id2.svg"
                  alt="Value Icon"
                />
              </div>
              <div className="cardText">
                <p className="text-blk cardHeading">Value</p>
                <p className="text-blk cardSubHeading">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>
            </div>
          ))}
          <a href="#">
            <button className="explore">Read more</button>
          </a> */}
        </div>
        <div className="imgContainer">
          <img
            className="blueDots"
            src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
            alt="background dots"
          />
          <img
            className="mainImgg"
            src={aboutus}
            alt="Main"
          />
                {/* <p className="text-blk cardHeading">International Community - Lithuania</p> */}

        </div>
        <img
          className="redDots"
          src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/cw3.svg"
          alt="Background Dots"
        />
      </div>
    </div>



    <div className="responsive-container-block bigContainer">
      <div className="responsive-container-block Container">
   
        <div className="imgContainer">
          <img
            className="blueDots"
            src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
            alt="background dots"
          />
          <img
            className="mainImgg"
            src={aboutus2}
            alt="Main"
          />
                <p className="text-blk cardHeading">Old town visit by Rubina Avetisyan - Klaipeda</p>

        </div>
        
        <div className="responsive-container-block textSide">
          {/* <p className="text-blk heading"></p> */}
          <h2>Why I Founded Future MedsAcademy</h2>
          <p className="text-blk subHeading">
          When I decided to pursue medicine in Italy, I quickly realized how difficult and confusing the process could be—especially for non-European students. There was a lack of proper guidance, and many consultancies were misleading students with incorrect information. I knew something had to change. As a medical student myself, I understand the emotions, challenges, and uncertainties that come with this journey. This is why I created Future MedsAcademy—to provide aspiring medical students with accurate information, structured guidance, and personalized support. 
          </p>
          {/* {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12"
            >
              <div className="cardImgContainer">
                <img
                  className="cardImg"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/id2.svg"
                  alt="Value Icon"
                />
              </div>
              <div className="cardText">
                <p className="text-blk cardHeading">Value</p>
                <p className="text-blk cardSubHeading">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>
            </div>
          ))}
          <a href="#">
            <button className="explore">Read more</button>
          </a> */}
        </div>
        
      </div>
    </div>




    <div className="responsive-container-block bigContainer">
      <div className="responsive-container-block Container">
        
        <div className="responsive-container-block textSide">
          {/* <p className="text-blk heading">About Us</p> */}
          <h2>My International Exposure and Teaching Experience</h2>
          <p className="text-blk subHeading">
          Living and working in different countries has shaped me in many ways. In Saudi Arabia, I worked as a sales executive and a teacher, which helped me develop strong communication skills and an understanding of cultural diversity. I also taught high school students in India and worked as a private mathematics and physics tutor in Lithuania. These experiences not only strengthened my teaching abilities but also helped me understand the struggles students face in different education systems. Having built a network across forty-five countries, I have gained valuable insights into international admissions and bureaucratic procedures.
          </p>
          {/* {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12"
            >
              <div className="cardImgContainer">
                <img
                  className="cardImg"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/id2.svg"
                  alt="Value Icon"
                />
              </div>
              <div className="cardText">
                <p className="text-blk cardHeading">Value</p>
                <p className="text-blk cardSubHeading">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>
            </div>
          ))}
          <a href="#">
            <button className="explore">Read more</button>
          </a> */}
        </div>
        <img
          className="redDots"
          src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/cw3.svg"
          alt="Background Dots"
        />
        <div className="imgContainer">
          <img
            className="blueDots"
            src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
            alt="background dots"
          />
          <img
            className="mainImgg"
            src={aboutus3}
            alt="Main"
          />
                <p className="text-blk cardHeading">High School, Science Practical Examination.</p>

        </div>
      </div>
    </div>





    <div className="responsive-container-block bigContainer">
      <div className="responsive-container-block Container">
     
        <div className="imgContainer">
          <img
            className="blueDots"
            src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
            alt="background dots"
          />
          <img
            className="mainImgg"
            src={amir}
            alt="Main"
          />
                <p className="text-blk cardHeading">Awarded with C1 Level of English at LCC International University.</p>

        </div>
        <div className="responsive-container-block textSide">
          {/* <p className="text-blk heading"></p> */}
          <h2>The Challenges I Faced and How Future MedsAcademy Helps</h2>
          <p className="text-blk subHeading">
          My own journey to studying medicine in Italy was filled with obstacles. I struggled to find reliable information on IMAT preparation, visa applications, scholarships, and documentation. Many students go through the same difficulties, and that’s exactly why Future MedsAcademy exists—to ensure no student has to face these challenges alone. We provide mentorship programs, step-by-step guidance on admissions, visa assistance, and support with scholarships, accommodation, and bureaucracy.
          </p>
          {/* {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12"
            >
              <div className="cardImgContainer">
                <img
                  className="cardImg"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/id2.svg"
                  alt="Value Icon"
                />
              </div>
              <div className="cardText">
                <p className="text-blk cardHeading">Value</p>
                <p className="text-blk cardSubHeading">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>
            </div>
          ))}
          <a href="#">
            <button className="explore">Read more</button>
          </a> */}
        </div>
       
      </div>
    </div>









    
    <div className="responsive-container-block bigContainer">
      <div className="responsive-container-block Container">
        
        <div className="responsive-container-block textSide">
          {/* <p className="text-blk heading">About Us</p> */}
          <h2>My Vision for the Future</h2>
          <p className="text-blk subHeading">
          Future MedsAcademy has already grown into a trusted platform for medical aspirants, and I see it expanding even further in the coming years. My goal is to establish it as a well-known and respected name in the Italian medical education community. In the next five years, I envision Future MedsAcademy becoming the go-to organization for students who dream of studying medicine in Italy—offering them the best quality education, guidance, and mentorship.
At Future MedsAcademy, we are more than just an institution. We are a community of students, mentors, and professionals working together to make medical education in Italy accessible and stress-free. I am committed to ensuring that every student who joins us feels supported and confident in their journey toward becoming a doctor.

          </p>
          {/* {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12"
            >
              <div className="cardImgContainer">
                <img
                  className="cardImg"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/id2.svg"
                  alt="Value Icon"
                />
              </div>
              <div className="cardText">
                <p className="text-blk cardHeading">Value</p>
                <p className="text-blk cardSubHeading">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>
            </div>
          ))}
          <a href="#">
            <button className="explore">Read more</button>
          </a> */}
        </div>
        <img
          className="redDots"
          src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/cw3.svg"
          alt="Background Dots"
        />
        <div className="imgContainer">
          <img
            className="blueDots"
            src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
            alt="background dots"
          />
          <img
            className="mainImgg"
            src={allinone}
            alt="Main"
          />
                <p className="text-blk cardHeading">International contacts from 45 different countries.</p>

        </div>
      </div>
    </div>
    
    </>
  );
};

export default AboutUs;
